module.exports = __webpack_public_path__ + "img/salvar.9f77f2e6.png";